/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Peak_Power_RangeInputs */

const en_exp_peak_power_range = /** @type {(inputs: Exp_Peak_Power_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The bars sit on a log scale relative to your highest value — so a 5-second sprint doesn't flatten your long efforts. You start on your best 20 minutes — hover or tap a bar to see another window. Your 20-minute peak says a lot about your FTP: it sits around 95 % of your best 20 minutes.`)
};

const de_exp_peak_power_range = /** @type {(inputs: Exp_Peak_Power_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Balken sind logarithmisch an deinem höchsten Wert ausgerichtet — so drückt ein 5-Sekunden-Sprint deine langen Anstrengungen nicht platt. Du startest bei deinen besten 20 Minuten — fahr über einen Balken oder tipp drauf, um ein anderes Fenster zu sehen. Dein 20-Minuten-Wert verrät viel über deine FTP: Sie liegt bei etwa 95 % deiner besten 20 Minuten.`)
};

/**
* | output |
* | --- |
* | "The bars sit on a log scale relative to your highest value — so a 5-second sprint doesn't flatten your long efforts. You start on your best 20 minutes — hove..." |
*
* @param {Exp_Peak_Power_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_peak_power_range = /** @type {((inputs?: Exp_Peak_Power_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Peak_Power_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_peak_power_range(inputs)
	return de_exp_peak_power_range(inputs)
});